import {
    IonItem,
    IonIcon,
    IonButton,
    useIonActionSheet,
    IonNote,
    IonText,
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    pencil,
    close,
    chevronDownCircleOutline,
    chevronUpCircleOutline
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { colorTheme } from '../../utils/constants';

// All actions
const A_EDIT = 'Edit';
const A_CANCEL = 'Cancel';
const A_DELETE = 'Delete';

const PropertyListItem = ({property, propertyId, showDetails, paymentMethod, handlePropertyAction, currency, userAllPerms}) => {
    const [showExtraDetails, setShowExtraDetails] = useState(false);
    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])

    const [present] = useIonActionSheet();

    const [extraData, setExtraData] = useState([
        { label: "Property", value: property.propertyName },
        { label: "Number of Units", value: property.numUnits },
        { label: "City", value: property.city },
        { label: "Address", value: property.address },
        { label: "Water Rate", value: `${property.waterRate} ${currency}` },
        { label: "Electricity Rate", value: `${property.electricityRate} ${currency}` },
        { label: "Payment Method", value: paymentMethod }
    ]);

    const actionsRequiringAllPropertyPerms = [A_EDIT, A_DELETE];

    const open = async () => {
        const mode = getMode();
        const buttons = [{
          text:  A_EDIT,
          role: 'destructive',
          icon: mode !== 'ios' ? pencil : '',
          handler: () => {
              handlePropertyAction('edit', propertyId);
          }
        },
        {
          text: A_DELETE,
          icon: mode !== 'ios' ? trash : '',
          handler: () => {
            handlePropertyAction('delete', propertyId);
          }
        }, {
          text: A_CANCEL,
          role: 'cancel',
          icon: mode !== 'ios' ? close : '',
          handler: () => {}
        }];

        let filteredButtons = buttons;
        if(!userAllPerms.property){
            filteredButtons = filteredButtons.filter(button => !actionsRequiringAllPropertyPerms.includes(button.text));
        }

        present({
          header: property.propertyName + "  " + property.numUnits + " units",
          buttons: filteredButtons
        });
    }
    return (
        <div className='mx-1 mx-md-4' key={propertyId}>
            <Row style={{width: '100%'}} className='my-2 mx-0 py-1 shadow-sm rounded'>
          <Row className='rounded mx-0 px-0'
          >
            <Col id='property-page-expand-details' onClick={ () => { setShowExtraDetails(!showExtraDetails)} } xs={7} md={6}>
              <Row>
              <Col xs={12} md={6}>
                <div className="d-flex align-items-center">
                  <strong>{property.propertyName}</strong>
                  <IonIcon
                    style={{fontSize: '20px', color: 'var(--ion-color-primary)', marginRight: '10px' }}
                    icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                  ></IonIcon>
                </div>
              </Col>
              <Col xs={12} md={5}>
                <IonNote className='text-sm'>{property.city || 'No address'}</IonNote>
              </Col>
              </Row>
            </Col>

            <Col className='px-0' xs={4} md={5}>
              <Row>
              <Col xs={12} md={5} >
                <IonText><strong>{property.numUnits} UNITS</strong> <span style={{fontSize: '12px'}}></span></IonText>
              </Col>
              <Col xs={12} md={5} >
                <IonNote className='text-sm'>{paymentMethod || 'No payment method'}</IonNote>
              </Col>
              </Row>
            </Col>

            <div style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon onClick={open} size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon id='property-page-menu-items' onClick={open} size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div>
          </Row>

            {showExtraDetails && (<Row
              style={{backgroundColor: colorTheme["primary"]["25"] }}
              className='mx-0 px-0 mb-2 py-3 rounded tenant-list-row'>
              <Row>
                <IonButton 
                  fill="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  Options
                </IonButton>
              </Row>
              { extraData.map((data, index) => (
                <Row key={index} className='border-bottom ml-0.5 my-1'>
                  <Col  xs={5} md={3}><strong>{data.label}</strong></Col>
                  <Col xs={7} md={8}>
                    <span style={{fontSize: '16px'}}>{data.value}</span>
                  </Col>
                </Row>
              ))}
            </Row>)}
            </Row>
        </div>
    )
}
export default PropertyListItem;